<template>
  
  <div class="book-cate">
    <h3><i class="iconfont icon-file-list-2-line"></i><span>目录</span></h3>
    <ul class="cateList">
      <li v-for="(item,index) in list" :key="index" @click="goPage(item)" v-if="item.title" :title="item.title">
          <span>{{item.title}}</span><em class="pageNum" v-if="item.abs_page_number">{{item.abs_page_number}}</em>
      </li>
      
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BookCatelog',
  props: {
    id:String || Number,
    list:Array
  },
  data(){
    return{
    }
  },
  methods: {
    goPage(item){
      this.$emit("changePage",item)
    }
  },
}
</script>
<style  lang="scss">
$main-color:#B41717;

//文字两行且显示省略号
@mixin text-el($line){
  @if $line==1{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
  }
  @else{
    display: -webkit-box;
    -webkit-line-clamp: $line;
    line-clamp: $line;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
  }
}


.book-cate {
  color: $main-color;
  font-size: 14px;

  h3 {
    border-bottom: 1px solid #f1f1f1;
    background: #fff;
    position: sticky;
    z-index: 2;
    top: 0;
    padding: 0 0 20px;

    .iconfont {
      font-size: 20px;
      margin-right: 10px;
    }
  }

  ul {
    overflow: hidden;
    transition: all 0.3s;

    &.unfold {
      height: auto;
    }

    li {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #d9d9d9;
      padding-left: 22px;
      position: relative;
      box-sizing: border-box;
      color: #222;
      cursor: pointer;
      &::before {
        content: "";
        width: 4px;
        height: 4px;
        background: #999999;
        position: absolute;
        left: 10px;
        top: 50%;
        margin-top: -2px;
      }

      &:hover {
        color: $main-color;
      }

      .pageNum {
        float: right;
      }

      span {
        display: inline-block;
        white-space: nowrap;
        max-width:640px;
        @include text-el(1);
      }
    }
  }
  .bookCate-box & ul li span{
    max-width: 80%;
  }
}

</style>